/* uhm-fcl-v2.js: search, brand filter and "show all" for sections/uhm-fcl.liquid. No dependencies.
   Codes load from assets/uhm-fcl-codes.json (asset_url of the current theme) on first use. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fcl]');
  if (!root) return;
  var form = root.querySelector('[data-fcl-form]');
  var input = root.querySelector('[data-fcl-input]');
  var out = root.querySelector('[data-fcl-out]');
  var brandBtns = root.querySelectorAll('[data-fcl-brand]');
  var data = null, loading = null, brand = '';

  var BRAND_WORDS = {
    goodman: 'Goodman', amana: 'Amana', daikin: 'Daikin', carrier: 'Carrier', bryant: 'Bryant', payne: 'Payne',
    trane: 'Trane', 'american standard': 'American Standard', rheem: 'Rheem', ruud: 'Ruud', lennox: 'Lennox',
    heil: 'Heil', tempstar: 'Tempstar', comfortmaker: 'Comfortmaker', arcoaire: 'Arcoaire', keeprite: 'KeepRite',
    york: 'York', coleman: 'Coleman', luxaire: 'Luxaire', ducane: 'Ducane', armstrong: 'Armstrong Air', infinity: 'Carrier', evolution: 'Bryant'
  };
  var STOP = /\b(error|fault|code|codes|furnace|flashing|light|led|what|does|mean|means|my|on|the|a|is)\b/g;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load() {
    if (data) return Promise.resolve(data);
    if (!loading) loading = fetch(root.getAttribute('data-src'), { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (j) { data = j.codes; return data; });
    return loading;
  }
  function track(ev, extra) { try { window.dataLayer = window.dataLayer || []; var p = { event: ev }; for (var k in extra) p[k] = extra[k]; window.dataLayer.push(p); } catch (e) {} }

  function parse(raw) {
    var q = ' ' + raw.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
    var b = '';
    Object.keys(BRAND_WORDS).sort(function (x, y) { return y.length - x.length; }).some(function (w) {
      if (q.indexOf(' ' + w + ' ') > -1) { b = BRAND_WORDS[w]; q = q.replace(' ' + w + ' ', ' '); return true; }
      return false;
    });
    q = q.replace(STOP, ' ').replace(/\b(blinks?|flash(es)?)\b/g, function (m) { return m.indexOf('b') === 0 ? 'blinks' : 'flashes'; }).replace(/\s+/g, ' ').trim();
    q = q.replace(/^(\d+) (blinks|flashes)$/, function (m, n, w) { return n + ' ' + (n === '1' ? w.replace(/es$|s$/, '') : w); });
    return { q: q, brand: b };
  }
  function score(c, q) {
    if (!q) return 1;
    var d = c.display.toLowerCase();
    if (d === q) return 100;
    for (var i = 0; i < c.aliases.length; i++) if (c.aliases[i] === q) return 95;
    if (/^\d+$/.test(q) && (d === q + ' flashes' || d === q + ' blinks' || d === q + ' flash' || d === q + ' blink')) return 90;
    if (q.length >= 3) {
      var hay = (c.title + ' ' + c.meaning + ' ' + c.causes.join(' ')).toLowerCase();
      var words = q.split(' '), all = words.every(function (w) { return hay.indexOf(w) > -1; });
      if (all) return c.title.toLowerCase().indexOf(q) > -1 ? 40 : 25;
    }
    return 0;
  }
  function inBrand(c, b) { return !b || c.brand === b || c.also.indexOf(b) > -1; }

  function card(c) {
    var tags = '<span class="fcl-tag fcl-tag--' + c.sev + '">' + c.sevLabel + '</span>';
    if (c.blower) tags = c.blowerTag + tags;
    var causes = c.causes.length ? '<div><h4>Usual causes</h4><ul>' + c.causes.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>' : '';
    var checks = c.checks.length ? '<div><h4>Check first</h4><ol>' + c.checks.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ol></div>' : '';
    var motor = '';
    if (c.blower === 'direct') motor = '<div class="fcl-res__motor"><p>This code points at the indoor blower motor. We stock remanufactured Genteq ECM blower motors, programmed for your equipment, with a 2-year warranty.</p><a class="fcl-btn" href="/pages/ecm-motor-cross-reference">Match my blower motor</a></div>';
    else if (c.blower === 'airflow') motor = '<div class="fcl-res__motor"><p>Airflow trips this code. Check the filter, blower wheel and static pressure first; a failing blower motor is one of the causes.</p><a class="fcl-btn fcl-btn--ghost" href="/pages/ecm-motor-cross-reference">Match my blower motor</a></div>';
    var src = c.src ? '<span>Source: <a href="' + esc(c.src.url) + '" target="_blank" rel="noopener nofollow">' + esc(c.src.label) + '</a></span>' : '';
    return '<article class="fcl-res"><div class="fcl-res__head">' + c.badge + '<div><h3 class="fcl-res__title">' + esc(c.title) + '</h3><p class="fcl-res__meta">' + esc(c.brandLine) + '</p></div><div class="fcl-res__tags">' + tags + '</div></div>' +
      '<p class="fcl-res__meaning">' + esc(c.meaning) + '</p><div class="fcl-res__cols">' + causes + checks + '</div>' + motor +
      '<div class="fcl-res__foot">' + src + '<a href="#' + c.fam + '">All ' + esc(c.famName) + ' codes</a></div></article>';
  }

  function render(raw, opts) {
    var p = parse(raw);
    var b = brand || p.brand;
    if (!p.q && !b) { out.innerHTML = ''; return; }
    load().then(function (codes) {
      var hits = [];
      codes.forEach(function (c) { if (!inBrand(c, b)) return; var s = score(c, p.q); if (s > 0) hits.push([s, c]); });
      hits.sort(function (x, y) { return y[0] - x[0] || x[1].order - y[1].order; });
      var label = (p.q ? '"' + raw.trim() + '"' : '') + (b ? (p.q ? ' on ' : '') + b + ' equipment' : '');
      if (!hits.length) {
        out.innerHTML = '<p class="fcl-out__empty" role="status">No code matches ' + esc(label) + '. Check how the board or wall control shows it (for example 3 flashes or 33), try without the brand, or <a href="/pages/contact-us">send us the code and your model number</a>.</p>';
      } else {
        var shown = hits.slice(0, 12);
        out.innerHTML = '<p class="fcl-out__count" role="status">' + hits.length + ' code' + (hits.length === 1 ? '' : 's') + ' for ' + esc(label) + (hits.length > 12 ? ', showing the first 12' : '') + '</p>' + shown.map(function (h) { return card(h[1]); }).join('');
      }
      if (!opts || !opts.silent) track('uhm_fcl_search', { fcl_query: raw.trim(), fcl_brand: b, fcl_results: hits.length });
    }).catch(function () {
      out.innerHTML = '<p class="fcl-out__empty" role="status">The lookup could not load. Browse the codes by brand below.</p>';
    });
  }

  form.addEventListener('submit', function (e) { e.preventDefault(); render(input.value); });
  input.addEventListener('focus', load, { once: true });
  var t; input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { if (input.value.trim().length >= 1) render(input.value, { silent: true }); else if (!brand) out.innerHTML = ''; }, 220); });
  function setBrand(v) { brand = v; brandBtns.forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-fcl-brand') === brand ? 'true' : 'false'); }); }
  root.querySelectorAll('[data-fcl-example]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('data-fcl-ex-brand')) setBrand(b.getAttribute('data-fcl-ex-brand'));
      input.value = b.getAttribute('data-fcl-example');
      render(input.value);
    });
  });
  brandBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-fcl-brand');
      setBrand(brand === v ? '' : v);
      render(input.value);
    });
  });
  root.querySelectorAll('[data-fcl-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var table = document.getElementById(btn.getAttribute('aria-controls'));
      var open = table.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    });
  });
  // Shareable lookups: ?code=33&brand=Carrier
  try {
    var sp = new URLSearchParams(window.location.search);
    if (sp.get('code')) { input.value = sp.get('code'); if (sp.get('brand')) setBrand(sp.get('brand')); render(input.value, { silent: true }); }
  } catch (e) {}
})();
